import React from 'react'
import '../styles/index.scss'
import '../styles/custom.scss'

import Header from "../components/header"
import SeoComponent from "../components/seo"

const Layout = ({ showHeader, headerBackBtn, children }) => {
    return (
        <>
            { showHeader && <Header backBtn={headerBackBtn} /> }
            <SeoComponent />
            {children}
        </>
    )
}

export default Layout
